import { ClientInput } from 'admin/inputs/ClientInput';
import { BooleanInput, Create, getRecordFromLocation, RadioButtonGroupInput, SimpleForm } from 'react-admin';
import { useLocation } from 'react-router-dom';

import { REPORT_TYPE_CHOICES } from './reportUtils';

export const ReportCreate: React.FC = () => {
  const location = useLocation();
  const record = getRecordFromLocation(location);

  return (
    <Create>
      <SimpleForm>
        <ClientInput disabled={!!record?.clientId} label="Klient" source="clientId" />
        <BooleanInput defaultValue={false} label="Publikovať" source="published" />
        <RadioButtonGroupInput choices={REPORT_TYPE_CHOICES} label="Typ" source="type" sx={{ width: '40em' }} />
      </SimpleForm>
    </Create>
  );
};
